export default __webpack_public_path__ + "static/media/sales.a8e3944b.svg";